import { jsx } from "react/jsx-runtime";
import { Skeleton } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import LottieDefault from "react-lottie";
import brandclub_colors from "../../../colors/brandclubColors.js";
import { ProductGrid } from "../../SearchResults/SearchResultsStyles.js";
import branclubloading from "./brandclub_logo_load.json.js";
const Lottie = LottieDefault;
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: branclubloading,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};
const ProductGridLoading = () => {
  return /* @__PURE__ */ jsx(ProductGrid, { containerWidthOverride: false, children: Array.from(Array(10).keys()).map((i, idx) => {
    return /* @__PURE__ */ jsx(
      Skeleton,
      {
        variant: "rectangular",
        width: "100%",
        height: 434,
        style: { borderRadius: 12 },
        sx: { bgcolor: "#f6f8fa" }
      },
      idx
    );
  }) });
};
const BrandclubLoading = ({
  type = "star",
  lottieProps,
  width
}) => {
  if (type === "productGrid") {
    return /* @__PURE__ */ jsx(ProductGridLoading, {});
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        justifyContent: "center",
        alignItems: "center",
        display: "flex"
      },
      children: type === "star" ? /* @__PURE__ */ jsx(Lottie, { options: defaultOptions, width: width || 200, ...lottieProps }) : /* @__PURE__ */ jsx(CircularProgress, { size: width || 100, sx: { color: brandclub_colors.mainSeriesColor } })
    }
  );
};
export {
  BrandclubLoading as default
};
//# sourceMappingURL=index.js.map
